export default __webpack_public_path__ + "static/media/benefit3.8c18c620.svg";